module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/zh-hans_hokkaido-3377f0e3f3f621c09d052da647488874.jpg";